import React, { useState, useEffect } from "react";
import Loader from "shared-anpost-components/components/loader/Loader";
import BlankScreenStyled from "./blankScreen.styled";

const BlankScreen = () => {
    const [showLoader, setShowLoader] = useState(false);

    useEffect(() => {
        const timeout = setTimeout(() => setShowLoader(true), 300);
        return () => clearTimeout(timeout);
    }, []);

    if (!showLoader) return null;

    return (
        <BlankScreenStyled>
            <Loader local />
        </BlankScreenStyled>
    );
};

export default BlankScreen;
